import { render } from "./customerPurchases.vue?vue&type=template&id=48d92530&ts=true"
import script from "./customerPurchases.vue?vue&type=script&lang=ts"
export * from "./customerPurchases.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__